<template>
  <div>
    <WizardDetailWrapper
      :class="['tw-mb-[25px]']"
      :title="item.title"
      :show-accordion="item.showAccordion"
      :is-verified="item.isVerifiedDns"
      :is-verified-email="item.isVerifiedEmail"
      :is-show-tag-verified="true"
      :data="data"
      :page-active="idPage.domainPage"
      :show-question="false"
      :validation="v$.domainName"
      :show-validate-now="true"
      :is-focus="isFocus"
      :is-api-error="statusInPageClone"
    >
      <template #title>
        <div class="enter__name" style="position: relative; width: 100%">
          <span v-if="item.domainName && !item.isEdit">{{
            item.domainName
          }}</span>
          <input
            v-else
            :id="`input-domain-${data.index}`"
            v-model="item.domainName"
            class="enter__name"
            :placeholder="
              getComponentUiText(
                'app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1',
              )
            "
            style="border: unset; background-color: unset"
            @input="updateStore"
            @click.stop
            @blur="onBlurs"
            @focus="onFocus"
          />
          <span
            v-if="!item.domainName"
            class="asterisk"
            style="position: absolute; top: -3px; color: red"
            >*</span
          >
        </div>
      </template>
      <MoreDetails
        v-if="isMoreDetails"
        :classes-more-detail="'!tw-p-0'"
        :is-show-questions="false"
      />
    </WizardDetailWrapper>
  </div>
</template>

<script setup lang="ts">
import { useVuelidate } from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import { Ref, ref, computed, onMounted, reactive, watch } from "vue";
import WizardDetailWrapper from "./wizardDetailWrapper.vue";
import MoreDetails from "./moreDetails.vue";
import { idWizardPage as idPage, statusPage } from "@/utils/constants";
import {
  IsSpecialCharDomainValid,
  getComponentUiText,
} from "@/utils/utilities";
import store from "@/store";
import { tlDomain } from "@/utils/validationRules";
import debounce from "lodash.debounce";
const isMoreDetails = ref(false);
const currentOrg = computed(() => store.state.Org.currentOrg);
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  currentIndex: {
    type: Number,
    required: true,
  },
  data: {
    type: Object,
    required: true,
  },
  statusInPage: {
    type: Object,
    default: () => ({
      statusPage: statusPage.NotChange,
      dataError: [],
    }),
  },
});
const item = ref(props.data.item);
watch(
  () => props.data.item,
  (newValue) => {
    item.value = props.data.item;
  },
  { immediate: true },
);
const bodyAPIError = computed(() => {
  if (
    !item.value.id &&
    props.statusInPage.dataError.length > 0 &&
    item.value.isCallAPI
  ) {
    return true;
  }
  return (
    item.value.id &&
    props.statusInPage.dataError.find((i) => i.id === item.value.id)
  );
});
const statusInPageClone = ref(bodyAPIError);
const isFocus: Ref<boolean> = ref(false);
const rules = {
  domainName: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
    specialChar: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-base-input-email-invalid-special-domain-characters-1",
        ),
      IsSpecialCharDomainValid,
    ),
    domain: helpers.withMessage(
      () =>
        getComponentUiText(
          "app-settings-domain-add-modal-domain-invalid-error-message-1",
        ),
      tlDomain,
    ),
  },
};

const v$ = useVuelidate(rules, item as any);
const saveChanges = async () => {
  await v$.value.$validate();
  // true is not error
  return !v$.value.$error;
};
defineExpose({
  saveChanges,
});
const emits = defineEmits(["changeStatusAddDomain"]);
const debouncedUpdate = debounce((e) => {
  item.value.domainName = e;
  statusInPageClone.value && delete statusInPageClone.value.name;
  statusInPageClone.value && delete statusInPageClone.value.id;
  store.commit("SetupWizard/SET_DOMAIN_NAME", {
    value: { ...item.value, isCallAPI: false },
    _index: props.currentIndex,
    currentOrg: currentOrg.value.id,
  });
  emits("changeStatusAddDomain", true);
}, 300);
const updateStore = (e) => {
  debouncedUpdate(e.target.value);
};

const onBlurs = () => {
  isFocus.value = false;
};

const onFocus = () => {
  isFocus.value = true;
};

onMounted(() => {
  const input = document.querySelector(".enter__name") as HTMLInputElement;
  const asterisks = document.querySelectorAll(".asterisk");

  if (input && asterisks.length) {
    adjustAsteriskPosition();
  }

  // Function declarations
  function adjustAsteriskPosition() {
    const placeholderWidth = getTextWidth(
      getComponentUiText(
        "app-menu-submenu-home-setup-wizard-modal-domain-placeholder-input-1",
      ),
      getComputedStyle(input).font,
    );
    asterisks.forEach((asterisk) => {
      const ele = asterisk as HTMLElement;
      if (ele) {
        ele.style.left = `${placeholderWidth + 5}px`;
      }
    });
  }

  function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    if (context) {
      context.font = font;
    }
    return context ? context.measureText(text).width : 0;
  }
});
</script>
<style scoped>
::placeholder {
  color: #b7b7b7;
  font-size: 14px;
  font-family: Poppins;
  font-weight: 400;
}
.enter__name {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  font-family: Poppins;
  color: #211f58;
  width: 98%;
}
::-ms-input-placeholder {
  color: red;
}
@media screen and (max-width: 590px) {
  .enter__name {
    width: 100%;
  }
}
</style>
